import { receiptList } from "constants/receipt";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getReceiptList = async (
  dispatch,
  pageNum,
  filterParams
) => {
  try {
    const res = await api.receipt_list(pageNum, filterParams);
    dispatch({ type: receiptList, payload: res.data });
  } catch (error) {
    const status = error?.response?.status;

  if (status === 404) {
    dispatch({
      type: receiptList,
      payload: {
        code: 404,
        message: "No receipts found.",
        data: [],
      },
    });
    return;
  }
   authorizedUser(error?.response?.data);
    dispatch({
      type: receiptList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
export const downloadReceipt = async (id) => {
  try {
    const res = await api.download_receipt(id);
    return res;
  } catch (error) {
    authorizedUser(error?.response || error?.response?.data);
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: "Failed to download receipt. Please try again.",
      }
    );
  }
};
